import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M11.5 7.5c-3.252 0-4.787 1.132-5.352 1.684-.344.337-.824.762-1.45.997l-2.05.769a1 1 0 0 0-.648.936v.878a1 1 0 0 0 .53.883A3.5 3.5 0 0 1 8.663 14h6.674a3.5 3.5 0 0 1 6.326 0h.509c.017 0 .034 0 .049-.002.01-.357-.027-.93-.202-1.802-.08-.406-.38-.754-.966-1.051-.587-.298-1.322-.467-1.96-.556-1.027-.143-1.916-.715-2.555-1.348l.703-.71-.703.71C15.828 8.538 14.32 7.5 11.5 7.5ZM21.965 16h.207c.415 0 .88-.1 1.275-.375.422-.294.72-.76.762-1.343.04-.57-.006-1.364-.228-2.478-.249-1.242-1.148-1.999-2.022-2.443-.873-.442-1.857-.65-2.59-.753-.474-.066-.987-.355-1.424-.788C16.884 6.77 14.88 5.5 11.5 5.5c-3.778 0-5.814 1.34-6.75 2.255-.302.295-.535.471-.755.554l-2.048.768A3 3 0 0 0 0 11.886v.878a3 3 0 0 0 1.658 2.683l.344.172A3.5 3.5 0 0 0 8.965 16h6.07a3.501 3.501 0 0 0 6.93 0ZM5.5 14a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm13 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
